import script from "./faqsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./faqsSection.vue?vue&type=script&setup=true&lang=js"

import "./faqsSection.vue?vue&type=style&index=0&id=69e019a3&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69e019a3"]])

export default __exports__